<template>
  <div>
    <div :class="['select-custom', { error: isValidate }]">
      <label v-if="textFloat" class="main-label">
        {{ textFloat }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
   
      <multiselect
        :close-on-select="closeOnSelect"
        :clear-on-select="clearOnSelect"
        multiple
        :value="valueDisplay"
        @input="handleSelect"
        :options="options"
        :placeholder="placeholder"
        :track-by="valueField"
        :label="textField"
        :loading="isLoading"
        @remove="(val) => $emit('remove', val)"
        :disabled="disable"
      >
        <template #noResult> <div>No value found.</div> </template>
        <template #noOptions> <div>No value found.</div> </template>
      </multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: {
    options: { required: true, default: () => [] },
    placeholder: { required: false, default: "select or search value." },
    textField: { required: true },
    valueField: { required: true },
    value: { required: true },
    textFloat: { required: false },
    closeOnSelect: {
      required: false,
      default: false,
    },
    clearOnSelect: {
      required: false,
      default: false,
    },
    defaultValue: {
      required: false,
      default: false,
    },
    used: { required: false, default: false },
    isLoading: { required: false, default: false },
    disable: { required: false, default: false },
    isValidate: { required: false, type: Boolean },
    isRequired: { required: false },
    v: { required: false },
  },

  computed: {
    valueDisplay() {
      try {
        if (!this.used) {
          if (this.defaultValue) {
            return this.value;
          }

          return this.options.filter((el) =>
            this.value.includes(el[this.valueField])
          );
        }

        if (this.defaultValue) {
          return this.$store.state.filter[this.used];
        }

        return this.options.filter((el) =>
          this.$store.state.filter[this.used].includes(el[this.valueField])
        );
      } catch (error) {
        return;
      }
    },
  },

  methods: {
    handleSelect(value) {
      let val = this.defaultValue
        ? value
        : value.map((el) => el[this.valueField]);

      if (this.used) {
        this.$store.dispatch("setFilter", { key: this.used, value: val });
      }

      this.$emit("input", val);
    },
  },
};
</script>

<style>
.error .multiselect__tags {
  border-color: red !important;
}
</style>
